<mat-card class="meter-card-enhanced" [class.selected]="selected" appearance="outlined" (click)="onSelectionToggle()">
  
  <!-- Selection and Main Info Header -->
  <div class="card-header">
    <div class="header-left">
      <mat-checkbox 
        [checked]="selected"
        (change)="onSelectionToggle()"
        class="selection-checkbox"
        color="primary">
      </mat-checkbox>
      
      <div class="meter-icon d-none d-md-flex" [ngClass]="getFuelTypeClass(meter.fuelType)">
        <mat-icon>{{ getFuelTypeIcon(meter.fuelType) }}</mat-icon>
      </div>
      
      <div class="meter-info">
        <div class="meter-title-row">
          <h3 class="meter-number">{{ meter.meterNumber }}</h3>
          <mat-chip class="meter-type-chip">
            {{ getMeterTypeShortForm(meter.meterType) }}
          </mat-chip>
          <mat-chip 
            class="consent-status-chip d-none d-sm-inline-flex" 
            [ngClass]="getConsentStatusClass(meter.consentStatus)"
            [matTooltip]="'Expiry Date: ' + (meter.expiryDate | date:'dd MMM yyyy')">
            {{ meter.consentStatus }}
          </mat-chip>
        </div>
        <div class="meter-details">
          {{ getRelationshipDisplayText(meter.relationship) }}
        </div>
      </div>
    </div>

    <!-- Sharees Section in Header -->
    <div class="header-middle">
      @if (displayableShares().length > 0) {
        <div class="sharees-display">
          <!-- Always show count badge -->
          <div class="sharees-count-inline" (click)="onManageShares(); $event.stopPropagation()">
            <mat-icon [matBadge]="displayableShares().length" matBadgeColor="primary" class="shares-icon-inline">group</mat-icon>
          </div>

          <!-- Show first 2 shares as chips - only on large screens -->
          <div class="sharees-chips d-none d-lg-flex">
            @for (share of displayableShares().slice(0, 2); track share.shareId) {
              <mat-chip class="sharee-badge" [ngClass]="{'platform-share': share.shareType === 'platform', 'email-share': share.shareType === 'email'}" (click)="onManageShares(); $event.stopPropagation()">
                {{ share.shareeName }}
                <mat-icon matChipRemove (click)="revokeShare(share); $event.stopPropagation()" matTooltip="Revoke access for {{ share.shareeName }}">cancel</mat-icon>
              </mat-chip>
            }
          </div>

          <!-- Show +N more if there are more than 2 shares - only on large screens -->
          @if (displayableShares().length > 2) {
            <span class="more-shares-indicator d-none d-lg-inline" (click)="onManageShares(); $event.stopPropagation()">+{{ displayableShares().length - 2 }} more</span>
          }

          <!-- Show share names text on medium and smaller screens -->
          <span class="shares-text-mobile d-inline d-lg-none" (click)="onManageShares(); $event.stopPropagation()">
            {{ displayableShares().length === 1 ? displayableShares()[0].shareeName : displayableShares().length + ' shares' }}
          </span>
        </div>
      }
    </div>

    <div class="header-right">
      <button
        mat-button
        color="primary"
        (click)="onDownload(); $event.stopPropagation()"
        class="d-none d-md-inline-flex">
        <mat-icon>download</mat-icon>
        Download
      </button>
      
      @if (meter.consentStatus === 'Active') {
        <button
          mat-button
          color="warn"
          (click)="onWithdrawConsent(); $event.stopPropagation()"
          class="d-none d-lg-inline-flex">
          Withdraw
        </button>
      }

      <button
        mat-icon-button
        [matMenuTriggerFor]="meterMenu"
        (click)="$event.stopPropagation()"
        matTooltip="More options">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #meterMenu="matMenu">
        @if (displayableShares().length > 0) {
          <button mat-menu-item (click)="onManageShares()">
            <mat-icon>manage_accounts</mat-icon>
            <span>Manage Shares</span>
          </button>
        }
        <button mat-menu-item (click)="onDownload()">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </button>
        @if (meter.consentStatus === 'Active') {
          <button mat-menu-item (click)="onWithdrawConsent()">
            <mat-icon>key_off</mat-icon>
            <span>Withdraw Consent</span>
          </button>
        }
      </mat-menu>
    </div>
  </div>

</mat-card>